import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Tooltip from '@material-ui/core/Tooltip'

const useStyles = makeStyles(theme => ({
  arrow: {
    color: theme.palette.primary.light
  },
  tooltip: {
    backgroundColor: theme.palette.primary.light
  }
}))

export default function StyledTooltip (props) {
  const classes = useStyles()

  return <Tooltip arrow classes={classes} {...props} />
}
